import iconList from "js/tripper/icons.js";

const STAY_FALLBACK = "nights_stay";
const UNKNOWN_FALLBACK = "question_mark";

function transportIcon(mot) {
    return mot ? (iconList.transport[mot] ?? null) : null;
}

function locationIcon(location, { tracksMot, nested, isFirst, tripStartMot }) {
    if (!tracksMot) {
        return { name: null, reserve: !nested };
    }

    const implied = isFirst ? transportIcon(tripStartMot) : null;
    const name =
        transportIcon(location.mot) ??
        implied ??
        (location.nights > 0 ? STAY_FALLBACK : UNKNOWN_FALLBACK);

    return { name, reserve: true };
}

function tripEdgeIcon(mot, tracksMot) {
    if (!tracksMot) {
        return null;
    }

    return transportIcon(mot) ?? UNKNOWN_FALLBACK;
}

export { locationIcon, tripEdgeIcon, STAY_FALLBACK };
